import { usePageTitle } from "@/hooks/usePageTitle";
import { QueriesPage } from "@/components/queries";

const Queries = () => {
	usePageTitle("Queries");
	return <QueriesPage />;
};

export default Queries;
